var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { sendAjaxRequest } from "../API";
import { DATA_UTIL_CLIENT_ERROR_LOAD_DATA_FAILED, DATA_UTIL_CLIENT_ERROR_MISSING_BEARER, DATA_UTIL_CLIENT_ERROR_SAVE_DATA_FAILED, } from "../util/DataUtils";
const LOGPREFIX = "CommentsStore: ";
const commentsCache = new Map();
export const createCacheKey = (channelOwnerId, channelId, postOwnerId, postId) => {
    return channelOwnerId + ":" + channelId + ":" + postOwnerId + ":" + postId;
};
export const getCacheRecord = (channelOwnerId, channelId, postOwnerId, postId, cacheBusterStore) => {
    const cacheBuster = cacheBusterStore.getCacheBusterNumber();
    const cacheKey = createCacheKey(channelOwnerId, channelId, postOwnerId, postId);
    const record = commentsCache.get(cacheKey);
    if (!record || record.cacheBuster != cacheBuster) {
        commentsCache.delete(cacheKey);
        return undefined;
    }
    return record.postComments;
};
export const resetCache = () => {
    commentsCache.clear();
};
export const setCacheRecord = (channelOwnerId, channelId, postOwnerId, postId, cacheBusterStore, postComments) => {
    const cacheBuster = cacheBusterStore.getCacheBusterNumber();
    const cacheKey = createCacheKey(channelOwnerId, channelId, postOwnerId, postId);
    const record = {
        cacheBuster,
        postComments,
    };
    commentsCache.set(cacheKey, record);
};
export const addComment = (channelOwnerId, channelId, postOwnerId, postId, commentText, commentEmoji, callbacks, auth, cacheBusterStore, logger) => __awaiter(void 0, void 0, void 0, function* () {
    const apiCallback = (ok, status, message) => {
        if (ok) {
            logger.log(LOGPREFIX + "addComment: apiCallback OK");
            const obj = JSON.parse(message);
            logger.log(LOGPREFIX +
                "addComment: apiCallback OK - parsed output = " +
                JSON.stringify(obj));
            if (obj.bearer && obj.sequence) {
                logger.log(LOGPREFIX + "addComment: apiCallback OK - bearer and sequence set");
                auth.setBearerAndSequence(obj.bearer, obj.sequence, logger);
                resetCache();
            }
            else {
                callbacks.errorCallback(DATA_UTIL_CLIENT_ERROR_MISSING_BEARER, "API response does NOT contain bearer and sequence - " + message);
                return;
            }
            try {
                const result = JSON.parse(message);
                if (!result) {
                    throw new Error("Unable to decode save comments response.");
                }
                callbacks.okCallback(obj.clientDetailCode);
            }
            catch (err) {
                logger.error(LOGPREFIX +
                    "addComment: apiCallback ERROR = " +
                    status +
                    " " +
                    message);
                const clientDetailCode = DATA_UTIL_CLIENT_ERROR_LOAD_DATA_FAILED;
                if (err instanceof Error) {
                    callbacks.errorCallback(clientDetailCode, err.message);
                }
                else {
                    callbacks.errorCallback(clientDetailCode, "Unable to save comments.");
                }
            }
        }
        else {
            logger.error(LOGPREFIX + "addComment: apiCallback ERROR = " + status + " " + message);
            const clientDetailCode = DATA_UTIL_CLIENT_ERROR_LOAD_DATA_FAILED;
            callbacks.errorCallback(clientDetailCode, message);
        }
    };
    const path = "comments";
    const input = {
        operation: "addComment",
        channelOwnerId,
        channelId,
        postOwnerId,
        postId,
        emoji: commentEmoji,
        text: commentText,
        sequence: auth.sequence,
    };
    logger.log(LOGPREFIX + "addComment: input " + JSON.stringify(input));
    sendAjaxRequest(apiCallback, path, input, auth.bearer, cacheBusterStore, logger);
});
export const deleteComment = (channelOwnerId, channelId, postOwnerId, postId, commentId, callbacks, auth, cacheBusterStore, logger) => __awaiter(void 0, void 0, void 0, function* () {
    const apiCallback = (ok, status, message) => {
        if (ok) {
            logger.log(LOGPREFIX + "deleteComment: apiCallback OK");
            const obj = JSON.parse(message);
            logger.log(LOGPREFIX +
                "deleteComment: apiCallback OK - parsed output = " +
                JSON.stringify(obj));
            if (obj.bearer && obj.sequence) {
                logger.log(LOGPREFIX + "deleteComment: apiCallback OK - bearer and sequence set");
                auth.setBearerAndSequence(obj.bearer, obj.sequence, logger);
                resetCache();
            }
            else {
                callbacks.errorCallback(DATA_UTIL_CLIENT_ERROR_MISSING_BEARER, "API response does NOT contain bearer and sequence - " + message);
                return;
            }
            try {
                const result = JSON.parse(message);
                if (!result) {
                    throw new Error("Unable to decode delete comments response.");
                }
                callbacks.okCallback(obj.clientDetailCode);
            }
            catch (err) {
                logger.error(LOGPREFIX +
                    "deleteComment: apiCallback ERROR = " +
                    status +
                    " " +
                    message);
                const clientDetailCode = DATA_UTIL_CLIENT_ERROR_SAVE_DATA_FAILED;
                if (err instanceof Error) {
                    callbacks.errorCallback(clientDetailCode, err.message);
                }
                else {
                    callbacks.errorCallback(clientDetailCode, "Unable to delete comment.");
                }
            }
        }
        else {
            logger.error(LOGPREFIX +
                "deleteComment: apiCallback ERROR = " +
                status +
                " " +
                message);
            const clientDetailCode = DATA_UTIL_CLIENT_ERROR_SAVE_DATA_FAILED;
            callbacks.errorCallback(clientDetailCode, message);
        }
    };
    const path = "comments";
    const input = {
        operation: "deleteComment",
        channelOwnerId,
        channelId,
        postOwnerId,
        postId,
        commentId,
        sequence: auth.sequence,
    };
    logger.log(LOGPREFIX + "deleteComment: " + JSON.stringify(input));
    sendAjaxRequest(apiCallback, path, input, auth.bearer, cacheBusterStore, logger);
});
export const listComments = (channelOwnerId, channelId, postOwnerId, postId, callbacks, auth, cacheBusterStore, logger) => __awaiter(void 0, void 0, void 0, function* () {
    const cacheRecord = getCacheRecord(channelOwnerId, channelId, postOwnerId, postId, cacheBusterStore);
    if (cacheRecord) {
        logger.log("cache hit");
        callbacks.okCallback(1000, cacheRecord);
        return;
    }
    else {
        logger.log("cache miss");
    }
    const apiCallback = (ok, status, message) => {
        if (ok) {
            logger.log(LOGPREFIX + "listComments: apiCallback OK");
            const obj = JSON.parse(message);
            logger.log(LOGPREFIX +
                "listComments: apiCallback OK - parsed output = " +
                JSON.stringify(obj));
            try {
                const result = JSON.parse(message);
                if (!result || !result.postComments) {
                    throw new Error("Unable to decode list comments response.");
                }
                else {
                    // Sort
                    if (result.postComments.entries) {
                        result.postComments.entries.sort((a, b) => a.timestamp > b.timestamp
                            ? -1
                            : a.timestamp < b.timestamp
                                ? 1
                                : 0);
                    }
                }
                setCacheRecord(channelOwnerId, channelId, postOwnerId, postId, cacheBusterStore, result.postComments);
                callbacks.okCallback(obj.clientDetailCode, result.postComments);
                if (obj.bearer && obj.sequence) {
                    logger.log(LOGPREFIX +
                        "listComments: apiCallback OK - bearer and sequence set");
                    auth.setBearerAndSequence(obj.bearer, obj.sequence, logger);
                }
            }
            catch (err) {
                logger.error(LOGPREFIX +
                    "listComments: apiCallback ERROR = " +
                    status +
                    " " +
                    message);
                const clientDetailCode = DATA_UTIL_CLIENT_ERROR_LOAD_DATA_FAILED;
                if (err instanceof Error) {
                    callbacks.errorCallback(clientDetailCode, err.message);
                }
                else {
                    callbacks.errorCallback(clientDetailCode, "Unable to load comments.");
                }
            }
        }
        else {
            logger.error(LOGPREFIX +
                "listComments: apiCallback ERROR = " +
                status +
                " " +
                message);
            const clientDetailCode = DATA_UTIL_CLIENT_ERROR_LOAD_DATA_FAILED;
            callbacks.errorCallback(clientDetailCode, message);
        }
    };
    const path = "comments";
    const input = {
        operation: "listComments",
        channelOwnerId,
        channelId,
        postOwnerId,
        postId,
        sequence: auth.sequence,
    };
    logger.log(LOGPREFIX + "listComments: " + JSON.stringify(input));
    sendAjaxRequest(apiCallback, path, input, auth.bearer, cacheBusterStore, logger);
});
